









import WidgetFrame from "@/components/WidgetFrame.vue"
import {ChartDataTemplate} from "@/components/widgets/WidgetFather"
import {defineComponent, reactive, ref, watch} from "@vue/composition-api"
import Fitty from "@/components/misc/Fitty.vue"
import {fusionDataFetcher, setupConfigWatcher, setupParamWatcher} from "@/components/widgets/WidgetMother"
import {deepMerge} from "@/utils"

export default defineComponent({
  props: {
    config: Object,
    dataFetcher: {type: Function, required: true},
    titleCallback: Function,
    downloadUrl: String,
  },
  components: {
    Fitty, WidgetFrame,
  },
  setup(p) {
    const config = reactive(deepMerge({}, p.config) || {})
    const chartConfig = reactive({width: 0, height: 0, title: ""})
    const chartDS = reactive({value: ""})
    const fittyOptions = reactive({maxSize: 90, minSize: 15, multiLine: false})
    let update = ref(0)
    watch(() => chartConfig, (cc) => update.value++, {deep: true})
    const fetchData = fusionDataFetcher(p.dataFetcher as (params: any) => any)
    const chartDataConfig = reactive(ChartDataTemplate())
    const titleCallback = async (config: any) => chartConfig.title = p.titleCallback ? await p.titleCallback(config) : ""
    watch(() => p.config, (c) => deepMerge(config, c), {deep: true})
    setupParamWatcher(fetchData, chartDS, chartDataConfig, config)
    setupConfigWatcher(config, chartConfig, chartDataConfig, titleCallback)
    return {fittyOptions, chartDS, chartConfig, update}
  },
})
